import { Question } from "../../type";
import { headerBlank } from "./move";
import { getQuestionRange, getQuestionRangeWithId } from "./excelInfo";

export async function removeQuestionById(
  sheetName: string,
  questionId: string,
  nextQuestionId?: string
) {
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem(sheetName);

    const { rangeText } = await getQuestionRangeWithId(questionId, nextQuestionId, sheetName);
    // rangeTextの範囲を行ごと削除
    const deleteRange = sheet.getRange(rangeText);
    await deleteRange.getEntireRow().delete(Excel.DeleteShiftDirection.up);
  });
}

export async function removeQuestion(
  sheetName: string,
  question: Question,
  nextQuestionId?: string
) {
  // 設問を削除する
  return await Excel.run(async (context) => {
    try {
      const sheet = context.workbook.worksheets.getItem(sheetName);
      const { rangeText, firstRowIndex } = await getQuestionRange(
        question,
        nextQuestionId,
        sheetName
      );

      // ページ改があるかを確認
      const prevRowRange = `D${firstRowIndex + headerBlank}`;
      const prevRow = sheet.getRange(prevRowRange);
      prevRow.load("values");
      await context.sync();

      // 該当範囲のデータを行ごと削除
      if (prevRow.values[0][0] === "ページの始まり") {
        // 改ページごと削除
        const curRow = +rangeText.split(":")[0].replace("C", "");

        const targetRange = sheet.getRange(`C${curRow - 1}:${rangeText.split(":")[1]}`);
        targetRange.load("values");
        await context.sync();
        const cellValues = targetRange.values.filter((_, i) => i >= 1);

        targetRange.getEntireRow().delete(Excel.DeleteShiftDirection.up);
        await context.sync();

        return cellValues;
      } else {
        const targetRange = sheet.getRange(rangeText);
        targetRange.load("values");
        await context.sync();
        const cellValues = targetRange.values;

        targetRange.getEntireRow().delete(Excel.DeleteShiftDirection.up);
        await context.sync();

        return cellValues;
      }
    } catch (error) {
      console.error("Error removing question:", error);
      return [];
    }
  });
}
